/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgRoadsideServiceCar32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <g stroke='currentColor' strokeWidth={1.5}>
        <path
          strokeMiterlimit={2}
          d='M22.08 17.69v-4.494M22.4 29.76a3.52 3.52 0 100-7.04 3.52 3.52 0 000 7.04z'
        />
        <path d='M20 6.4a1.118 1.118 0 00-1.12-1.12 1.12 1.12 0 00-1.12 1.12v1.28H20V6.4z' />
        <path
          strokeMiterlimit={2}
          d='M25.68 26.458h4.264v-6.4c0-.526-.286-1.01-.748-1.262l-3.906-2.14-1.7-8.976h-8.326v8.352M15.264 16.032v10.426H19.2M-.96 26.458h16'
        />
        <path strokeMiterlimit={5} d='M15.36 23.04H-.48' />
        <path
          strokeLinecap='square'
          strokeMiterlimit={5}
          d='M-13.44 19.696V16.71c0-.942.41-1.834 1.124-2.448.898-.768 2.004-1.718 2.004-1.718a4.466 4.466 0 014.466-4.466h5.8c.848 0 1.644.414 2.13 1.108l2.352 3.358 5.152 1.108a3.662 3.662 0 012.892 3.58v2.426l-25.92.038v0z'
        />
        <path
          strokeMiterlimit={5}
          d='M9.28 16.16s.291.126.597.256c.45.192.934.292 1.424.292h.984M-10.759 12.546H4.435'
        />
        <path
          fill='#fff'
          strokeLinejoin='round'
          strokeMiterlimit={5}
          d='M4.708 21.892a2.234 2.234 0 100-4.468 2.234 2.234 0 000 4.468z'
        />
        <path d='M15.36 16.154h6.72' />
      </g>
      <defs>
        <clipPath id='roadside-service-car-32_svg__clip0'>
          <path fill='#fff' d='M0 0h32v32H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgRoadsideServiceCar32;
